import { Brand } from '@awazevr/design-system.components.awaze-theme-provider'
import {
  AGE_ACQUISITION_GOOGLE_FALLBACK_COT,
  AGE_ACQUISITION_GOOGLE_FALLBACK_HOS,
  AGE_ACQUISITION_GOOGLE_FALLBACK_NOV,
  OPTIMIZELY_VARIANT_KEYS,
} from '../../../constants'
import { useSpecificOptimizelyUserDecision } from '../optimizely-for-client'
import { GoogleSearchMethods } from '@awazevr/mfe-common.api.places-api'

/**
 * Determine which Google fallback method to use for the given brand.
 * We can run 3 xp's. 1 for each brand, so we can turn it off per brand.
 */
export function useGoogleFallback(brand: Brand): GoogleSearchMethods | null {
  let FLAG = null

  switch (brand) {
    case 'cottages.com':
      FLAG = AGE_ACQUISITION_GOOGLE_FALLBACK_COT
      break
    case 'hoseasons':
      FLAG = AGE_ACQUISITION_GOOGLE_FALLBACK_HOS
      break
    case 'novasol':
      FLAG = AGE_ACQUISITION_GOOGLE_FALLBACK_NOV
      break
  }

  const decision = useSpecificOptimizelyUserDecision(FLAG)

  if (!decision?.variationKey) {
    return null
  }

  switch (decision?.variationKey) {
    case OPTIMIZELY_VARIANT_KEYS.GOOGLE_FALLBACK_AUTOCOMPLETE:
      return 'autocomplete'
    case OPTIMIZELY_VARIANT_KEYS.GOOGLE_FALLBACK_TEXTSEARCH:
      return 'textsearch'
    case 'baseline':
      return null
    default:
      return null
  }
}
